import { render, staticRenderFns } from "./FamilyNew.vue?vue&type=template&id=7aedccf8"
import script from "./FamilyNew.vue?vue&type=script&lang=js"
export * from "./FamilyNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports